document.addEventListener('DOMContentLoaded', () => {
  const bannerButtons = document.querySelectorAll('[data-engraved-scroll-target]');

  bannerButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const rawTarget = button.getAttribute('data-engraved-scroll-target');

      if (!rawTarget) {
        return;
      }

      // 支持后台填写 "#section-id" 或 "section-id"，统一转换成可查询的 id。
      const targetId = rawTarget.replace(/^#/, '').trim();
      const targetElement = document.getElementById(targetId);

      if (!targetElement) {
        return;
      }

      // 使用浏览器原生平滑滚动，避免按钮直接跳转造成页面位置突变。
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  });
});